import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import counterReducer from "../features/counter/counterSlice";
import userReducer from "../features/player/playerSlice";
import themeReducer from "../features/theme/themeSlice";
import casinoThemeReducer from "../features/casinotheme";
import configReducer from "../features/configapp";

export const store = configureStore({
  reducer: {
    player: userReducer,
    theme: themeReducer,
    casinoTheme: casinoThemeReducer,
    counter: counterReducer,
    config: configReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
